/**
 * Move animals into a field.
 *
 * This helper function is separated from UpdateBiomassAfterMoveInDialog.tsx
 * to enable Fast Refresh. Non-component exports in the same file as components
 * break HMR.
 */

import { QueryClient } from "@tanstack/react-query";
import { AnalyticsEvents, analytics } from "common/analytics";
import { queryClient } from "common/queryClient";
import { moveIntoField } from "services";

export async function moveAnimalsIn(
  newFieldWithAnimals: { guid: string; name: string },
  currentFieldWithAnimals: { guid: string } | undefined,
  dateTimeIn: Date,
  notify: (message: string, severity?: string) => void,
  t: (key: string, values?: Record<string, unknown>) => string,
  qc: QueryClient = queryClient
) {
  try {
    await moveIntoField(
      newFieldWithAnimals.guid,
      currentFieldWithAnimals?.guid,
      dateTimeIn,
      qc
    );

    analytics.track(AnalyticsEvents.ANIMAL_MOVE_COMPLETED);
    notify(
      t("fieldlistmenu.notification.moveInSuccess", {
        fieldName: newFieldWithAnimals.name,
      }),
      "success"
    );
  } catch (e) {
    console.log(e);
    analytics.track(AnalyticsEvents.ANIMAL_MOVE_FAILED);
    notify(
      t("fieldlistmenu.notification.moveInFailed", {
        fieldName: newFieldWithAnimals.name,
      }),
      "error"
    );
  }
}
